/** Exponential backoff with full jitter: 1 s, 2 s, 4 s ... capped at 30 s. */
export function backoffDelay(attempt: number, baseMs = 1000, maxMs = 30000, random = Math.random): number {
  const ceiling = Math.min(maxMs, baseMs * 2 ** Math.max(0, attempt));
  // Keep at least half the ceiling so reconnect storms still spread out but never spin.
  return Math.round(ceiling / 2 + random() * (ceiling / 2));
}
